import { useTranslation } from 'react-i18next';

export const useAnalyticsTranslation = () => useTranslation('analytics');
